@if (bontonPanel.isB2B()) {
<div class="flex flex-col flex-auto min-w-0 min-h-[calc(100vh-16rem)]">
  <form [formGroup]="formGroup" class="flex flex-col px-4 pt-5 white-bg rounded-lg -mt-20 shadow pb-5 relative"
    [class]="!wlSettingsDetails.is_wl ? 'pb-7' : ''">
    <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
      <div class="flex flex-row items-center w-1/2">
        <div class="flex flex-col w-[100%] p-3 field-blue-bg rounded-lg max-h-16 cursor-pointer"
          (click)="openDestination()">
          <span class="text-gray text-md">Destination</span>
          <mat-select #destinationSelect class="font-semibold right-mat-select" formControlName="destination_id"
            [compareWith]="compareWith">
            <mat-option>
              <ngx-mat-select-search placeholderLabel="Search Destination"
                noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilterNew">
              </ngx-mat-select-search>
            </mat-option>
            @for (ct of destinationListNew; track ct) {
            <mat-option [value]="ct">
              <div class="flex flex-col justify-center">
                <span class="font-medium items-center flex">
                  @if (ct.type == 'City') {
                  <mat-icon svgIcon="heroicons_outline:building-office-2"></mat-icon>
                  }
                  @if (ct.type == 'Destination') {
                  <mat-icon svgIcon="heroicons_outline:map-pin"></mat-icon>
                  }
                  {{ct.name}}
                </span>
              </div>
            </mat-option>
            }
          </mat-select>
        </div>
      </div>
      <div class="flex flex-row items-center w-1/2">
        <div class="flex flex-col w-[50%] field-blue-bg rounded-lg p-3 cursor-pointer" (click)="picker.open()">
          <span class="text-gray text-md">Departure</span>
          <div class="flex flex-row">
            <input matInput class="font-semibold cursor-pointer" [readonly]="true" [matDatepicker]="picker"
              [min]="minDate" formControlName="departure_date" />
          </div>
          <mat-datepicker #picker></mat-datepicker>
        </div>
        <div class="flex flex-col flex-grow w-[48%] ml-[2%] p-3 field-blue-bg rounded-lg cursor-pointer"
          (click)="travellersClass()">
          <span class="text-gray text-md">Pax</span>
          <span class="font-semibold">{{
            formGroup.get("adult").value +
            " Adults" +
            " " +
            formGroup.get("child").value +
            " Child"
            }}</span>
        </div>
      </div>
    </div>
    @if(!wlSettingsDetails.is_wl) {
    <div class="flex justify-end absolute right-4 bottom-2" (click)="helpVideo('Holidays')">
      <div class="flex items-center gap-2 px-4 py-2 rounded-full cursor-pointer hover:bg-[#E8F1F8]">
        <span class="font-medium primary-text text-sm">NEED HELP?</span>
        <mat-icon svgIcon="youtube" class="icon-size-5"></mat-icon>
      </div>
    </div>
    }
    <div class="flex flex-row justify-center items-center -mb-13 mt-2">
      <button mat-raised-button class="primary-bg w-50 min-h-13 rounded-lg" (click)="detail()">
        <span class="white-text font-semibold text-lg">Search</span>
      </button>
    </div>
  </form>
  <!-- Domestic Package -->
  <div class="flex flex-col mb-6 mt-14">
    <span class="text-2xl font-bold">Domestic Package</span>
    <span class="text-sm">Explore Top Domestic Packages based on what Everyone is loving at the moment!</span>
  </div>
  <div class="flex flex-col relative">
    <div class="tab-content w-full">
      <ngx-slick-carousel class="carousel" #slickModal2="slick-carousel" [config]="slideConfig">
        @for (slide of DomDestinationsList; track slide; let i = $index) {
        <div ngxSlickItem (click)="topDestination(slide)" class="slide relative mx-2 rounded-lg cursor-pointer">
          <div class=" w-[237px] h-[250px] rounded-lg overflow-hidden">
            <img loading="lazy" [src]="slide.img" alt="slide"
              class="w-[237px] h-[250px] object-cover rounded-lg transform transition duration-1000 hover:scale-125">
          </div>
          <div class="pt-2">
            <span class="block font-semibold text-lg">{{
              slide.destination_name
              }}</span>
            <span class="font-sans font-bold text-lg primary-text pt-1">{{slide.currency }} {{slide.price}}
            </span>
            <span class="font-sans font-normal text-base text-gray"> Onwards</span>
          </div>
        </div>
        }
      </ngx-slick-carousel>
    </div>
    @if (DomDestinationsList.length >= 6) {
    <div
      class="flex flex-row justify-center items-center absolute h-12 w-12 white-bg rounded-full left-0 top-[110px] -ml-6 shadow cursor-pointer"
      (click)="slickModal2.slickPrev()">
      <mat-icon class="text-[#286494] relative left-1">arrow_back_ios</mat-icon>
    </div>
    }
    @if (DomDestinationsList.length >= 6) {
    <div
      class="flex flex-row justify-center items-center absolute h-12 w-12 white-bg rounded-full right-0 top-[110px] -mr-6 shadow cursor-pointer"
      (click)="slickModal2.slickNext()">
      <mat-icon class="text-[#286494]">arrow_forward_ios</mat-icon>
    </div>
    }
  </div>
  <!-- International Package -->
  <div class="flex flex-col mb-6 mt-6">
    <span class="text-2xl font-bold">International Package</span>
    <span class="text-sm">Explore Top International Packages based on what Everyone is loving at the moment!</span>
  </div>
  <div class="flex flex-col relative">
    <div class="tab-content w-full">
      <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
        @for (slide of IntDestinationsList; track slide; let i = $index) {
        <div ngxSlickItem (click)="topDestination(slide)" class="slide relative mx-2 rounded-lg cursor-pointer">
          <div class=" w-[237px] h-[250px] rounded-lg overflow-hidden">
            <img loading="lazy" [src]="slide.img" alt="slide"
              class="w-[237px] h-[250px] object-cover rounded-lg transform transition duration-1000 hover:scale-125">
          </div>
          <div class="pt-2">
            <span class="block font-semibold text-lg">{{
              slide.destination_name
              }}</span>
            <span class="font-sans font-bold text-lg primary-text pt-1">{{slide.currency }} {{slide.price}}
            </span>
            <span class="font-sans font-normal text-base text-gray"> Onwards</span>
          </div>
        </div>
        }
      </ngx-slick-carousel>
    </div>
    @if (IntDestinationsList.length >= 6) {
    <div
      class="flex flex-row justify-center items-center absolute h-12 w-12 white-bg rounded-full left-0 top-[110px] -ml-6 shadow cursor-pointer"
      (click)="slickModal.slickPrev()">
      <mat-icon class="text-[#286494] relative left-1">arrow_back_ios</mat-icon>
    </div>
    }
    @if (IntDestinationsList.length >= 6) {
    <div
      class="flex flex-row justify-center items-center absolute h-12 w-12 white-bg rounded-full right-0 top-[110px] -mr-6 shadow cursor-pointer"
      (click)="slickModal.slickNext()">
      <mat-icon class="text-[#286494]">arrow_forward_ios</mat-icon>
    </div>
    }
  </div>
  <!-- Destinations -->
  <div class="flex flex-col mb-6 mt-6">
    <span class="text-2xl font-bold">Top Destinations</span>
    <span class="text-sm">Explore Top Packages based on what Everyone loves now!</span>
  </div>
  <div class="flex flex-col relative">
    <div class="tab-content w-full">
      <ngx-slick-carousel class="carousel" #slickModal3="slick-carousel" [config]="slideConfig">
        @for (slide of topDestinationsList; track slide; let i = $index) {
        <div ngxSlickItem class="slide relative mx-2 rounded-lg black-shadow overflow-hidden cursor-pointer"
          (click)="topDestination(slide)">
          <div
            class="w-[237px] h-[250px] bg-cover shadow-md bg-no-repeat bg-center transform transition duration-1000 hover:scale-125"
            style="background-image:linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.897)),
                    url('{{slide.img}}');"></div>
          <div class="pt-2 absolute bottom-0 white-text flex flex-col justify-center items-center pb-3 w-full">
            <span class="block font-medium text-lg tracking-wider pb-1">{{
              slide.destination_name
              }}</span>
            <span class="text-sm font-extralight tracking-wider">{{ slide.packages }}+ Packages</span>
          </div>
        </div>
        }
      </ngx-slick-carousel>
    </div>
    @if (topDestinationsList.length >= 6) {
    <div
      class="flex flex-row justify-center items-center absolute h-12 w-12 white-bg rounded-full left-0 top-[110px] -ml-6 shadow cursor-pointer"
      (click)="slickModal3.slickPrev()">
      <mat-icon class="text-[#286494] relative left-1">arrow_back_ios</mat-icon>
    </div>
    }
    @if (topDestinationsList.length >= 6) {
    <div
      class="flex flex-row justify-center items-center absolute h-12 w-12 white-bg rounded-full right-0 top-[110px] -mr-6 shadow cursor-pointer"
      (click)="slickModal3.slickNext()">
      <mat-icon class="text-[#286494]">arrow_forward_ios</mat-icon>
    </div>
    }
  </div>
  @if (settings?.data?.android_app_link || settings?.data?.ios_app_link) {
  <div class="bg-add mt-10 mb-8 shadow rounded-xl h-[257px]">
    <div class="flex items-center justify-end h-full">
      <div class="flex flex-col gap-3 w-[710px] h-full justify-center">
        <p class="text-[18px] font-normal text-[#c6c6c6] max-w-[400px]">Get access to all Major Travel Services
          like Flights,
          Hotels, Bus, Holidays, and Visas at your Fingertips!</p>
        <div class="flex flex-row gap-3.5">
          @if (settings?.data?.ios_app_link) {
          <img loading="lazy" src="assets/images/image/app_store.webp" class="w-[150px] cursor-pointer" alt="app_store"
            (click)="openNewWindow(settings?.data?.ios_app_link)">
          }
          @if (settings?.data?.android_app_link) {
          <img loading="lazy" src="assets/images/image/google_play.webp" class="w-[170px] cursor-pointer"
            alt="google_play" (click)="openNewWindow(settings?.data?.android_app_link)">
          }
        </div>
      </div>
    </div>
  </div>
  }
</div>
} @else {
<!-- theme 1-->
@if (holidaysData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme1) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[400px] primary-bg w-full gray-text" style="background-image: url('{{holidaysData?.background_image}}');background-blend-mode: color !important;
    background-color: #0000007a !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[21rem]">
      <div class="flex flex-col">
        <div class="flex">
          <h1
            class="text-center text-[52px] justify-center font-bold font-Racing_Sans_One white-text flex w-full z-[99] tracking-[4px]">
            {{holidaysData?.title}}</h1>
        </div>
        <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote4">
            {{holidaysData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="pt-3">
    <div class="min-w-[1260px] max-w-[1260px] m-auto mt-[-68px] relative z-[99]">
      <div class="min-w-[1260px] max-w-[1260px] m-auto rounded-[10px]">
        <form [formGroup]="formGroup" class="flex flex-col">
          <div class="flex flex-row w-full overflow-hidden rounded-[10px] shadow-xl white-bg">
            <div class="flex flex-row w-full">
              <div class="flex flex-col border-r gray-border py-[25px] min-w-[600px] max-w-[600px] cursor-pointer"
                [ngClass]="selectedField == 'destination' ? 'secondary-bg' : ''" (click)="destinationSelect.open()">
                <span class="font-normal text-[15px] pl-6 font-Roboto text-secondary">Destination</span>
                <mat-select (click)="selectedField = 'destination'" #destinationSelect
                  class="pl-[22px] pt-3 font-bold rounded-[5px] pr-[15px] text-xl" formControlName="destination_id"
                  [compareWith]="compareWith">
                  <mat-option>
                    <ngx-mat-select-search placeholderLabel="Search Destination"
                      noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilterNew">
                    </ngx-mat-select-search>
                  </mat-option>
                  @for (ct of destinationListNew; track ct) {
                  <mat-option [value]="ct">
                    <div class="flex flex-col justify-center ml-3">
                      <span class="font-medium items-center flex">
                        @if (ct.type == 'City') {
                        <mat-icon svgIcon="heroicons_outline:building-office-2"></mat-icon>
                        }
                        @if (ct.type == 'Destination') {
                        <mat-icon svgIcon="heroicons_outline:map-pin"></mat-icon>
                        }
                        {{ct.name}}
                      </span>
                    </div>
                  </mat-option>
                  }
                </mat-select>
              </div>
              <div class="flex flex-col pl-[15px] min-w-[230px] max-w-[230px] border-r gray-border cursor-pointer"
                [ngClass]="selectedField == 'departure' ? 'secondary-bg' : ''"
                (click)="picker.open();selectedField = 'departure'">
                <div class="ml-[7px] py-[25px]">
                  <mat-label class="white-text text-[15px] items-center gap-1 flex">
                    <span class="pt-1 pb-1 pr-1"><img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                        alt="date_icon"></span>
                    <span class="ml-0 pr-3 pt-[2px] text-secondary">Departure</span>
                  </mat-label>
                  <input readonly class="font-Roboto font-bold text-xl pt-2 cursor-pointer max-w-[200px]" matInput
                    [matDatepicker]="picker" [min]="minDate" (click)="picker.open();selectedField = 'departure'"
                    formControlName="departure_date">
                  <mat-datepicker-toggle matSuffix [for]="picker" class="hidden"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </div>
              </div>
              <div class="min-w-[230px] max-w-[230px] flex flex-col pt-[28px] pb-[29px] pl-5 cursor-pointer"
                [ngClass]="selectedField == 'pax' ? 'secondary-bg' : ''"
                (click)="travellersClass();selectedField = 'pax'">
                <span class="text-[15px] rounded-lg w-full h-[24px] text-secondary">Pax</span>
                <div class="truncate pr-3 w-full rounded-md font-Roboto font-bold text-xl pt-[8px] cursor-pointer">
                  {{formGroup.get("adult").value + " Adults" + " " + formGroup.get("child").value
                  +"
                  Child"}}
                </div>
              </div>
              <div class="w-full h-full justify-end pr-5 flex items-center">
                <button class="primary-bg rounded-lg py-10 px-12" mat-flat-button (click)="detail()">
                  <span class="white-text font-semibold text-2xl font-Roboto">Search</span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
}
<!--Theme 2-->
@if (holidaysData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme2) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[375px] primary-bg w-full gray-text" style="background-image: url('{{holidaysData?.background_image}}');background-blend-mode: color !important;
    background-color: #0000007a !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[16.5rem]">
      <div class="flex flex-col">
        <div class="flex">
          <h1 class="text-center text-[52px] justify-center font-bold font-Dosis white-text flex w-full z-[99]">
            {{holidaysData?.title}}</h1>
        </div>
        <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote4">
            {{holidaysData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-[15px] mt-[-110px]">
    <div class="mr-6 rounded-[15px] min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup" class="flex flex-col px-4 pt-6 white-bg rounded-[15px] shadow-xl pb-5">
        <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
          <div
            class="flex flex-col min-w-[50%] max-w-[50%] h-[60px] border-2 pt-0 pb-3 pl-3 pr-3 rounded-lg cursor-pointer"
            [ngClass]="selectedField == 'destination' ? 'primary-border' : 'gray-border'"
            (click)="destinationSelect.open()">
            <span class="text-[15px] mt-[-11px] font-Roboto white-bg px-[10px] max-w-max font-medium"
              [ngClass]="selectedField == 'destination' ? 'primary-text' : 'text-secondary'">Destination</span>
            <mat-select (click)="selectedField = 'destination'" #destinationSelect
              class="mt-1 pl-2 font-bold font-Roboto text-2xl theme-black-text" [compareWith]="compareWith"
              formControlName="destination_id">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search Destination"
                  noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilterNew">
                </ngx-mat-select-search>
              </mat-option>
              @for (ct of destinationListNew; track ct) {
              <mat-option [value]="ct">
                <div class="flex flex-col truncate max-w-full h-15 justify-center">
                  <span class="font-normal items-center text-base flex">
                    @if (ct.type == 'City') {
                    <mat-icon svgIcon="heroicons_outline:building-office-2"></mat-icon>
                    }
                    @if (ct.type == 'Destination') {
                    <mat-icon svgIcon="heroicons_outline:map-pin"></mat-icon>
                    }
                    {{ct.name}}
                  </span>
                </div>
              </mat-option>
              }
            </mat-select>
          </div>
          <div [ngClass]="selectedField == 'departure' ? 'primary-border' : 'gray-border'"
            class="flex flex-col w-[25%] h-[60px] rounded-lg pb-3 pr-3 border-2 cursor-pointer"
            (click)="picker.open(); selectedField = 'departure'">
            <span class="text-[15px] mt-[-11px] ml-2 font-Roboto white-bg px-[5px] max-w-max font-medium"
              [ngClass]="selectedField == 'departure' ? 'primary-text' : 'text-secondary'">Departure</span>
            <div class="flex flex-row pl-3">
              <input class="font-semibold text-xl mt-1 w-full" [min]="minDate"
                (click)="picker.open(); selectedField = 'departure'" [readonly]="true" [matDatepicker]="picker"
                formControlName="departure_date" />
            </div>
            <mat-datepicker #picker></mat-datepicker>
          </div>
          <div
            class="flex flex-col flex-grow p-3 pl-0 min-w-[25%] max-w-[25%] white-bg rounded-lg border-2 h-[60px] cursor-pointer"
            (click)="travellersClass(); selectedField = 'pax'"
            [ngClass]="selectedField == 'pax' ? 'primary-border' : 'gray-border'">
            <span [ngClass]="selectedField == 'pax' ? 'primary-text' : 'text-secondary'"
              class="font-Roboto white-bg ml-2 px-[5px] max-w-max font-medium text-[15px] mt-[-23px]">Pax</span>
            <span class="font-bold pl-3 text-2xl font-Roboto theme-black-text pt-[3px]">{{
              formGroup.get("adult").value + " Adults" + " " +
              formGroup.get("child").value + " Child" }}</span>
          </div>
        </div>
        <div class="flex flex-row justify-center items-center mb-[-45px] space-x-4">
          <button mat-flat-button class="w-60 min-h-13 rounded-full primary-bg" (click)="detail()">
            <span class="white-text font-semibold text-2xl font-Inter">Search</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 3-->
@if (holidaysData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme3) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[375px] primary-bg w-full gray-text" style="background-image: url('{{holidaysData?.background_image}}');background-blend-mode: color !important;
    background-color: #0000007a !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[18.5rem]">
      <div class="flex flex-col">
        <div class="flex">
          <h1 class="text-center text-[52px] justify-center font-bold font-Dosis white-text flex w-full z-[99]">
            {{holidaysData?.title}}</h1>
        </div>
        <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote4">
            {{holidaysData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-xl mt-[-75px]">
    <div class="mr-6 rounded-[10px] min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup" class="flex flex-col px-4 pt-5 white-bg rounded-lg shadow-xl pb-5">
        <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
          <div class="flex flex-col min-w-[50%] max-w-[50%] h-[74px] py-3 px-2 secondary-bg rounded-lg cursor-pointer"
            (click)="destinationSelect.open()">
            <span class="text-lg secondary-bg px-[10px] max-w-max font-normal text-secondary">Destination</span>
            <mat-select class="mt-1 px-2 font-semibold text-xl" formControlName="destination_id" #destinationSelect
              [compareWith]="compareWith">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search Destination"
                  noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilterNew">
                </ngx-mat-select-search>
              </mat-option>
              @for (ct of destinationListNew; track ct) {
              <mat-option [value]="ct">
                <div class="flex flex-col truncate max-w-full h-15 justify-center">
                  <span class="font-normal items-center text-base flex">
                    @if (ct.type == 'City') {
                    <mat-icon svgIcon="heroicons_outline:building-office-2"></mat-icon>
                    }
                    @if (ct.type == 'Destination') {
                    <mat-icon svgIcon="heroicons_outline:map-pin"></mat-icon>
                    }
                    {{ct.name}}
                  </span>
                </div>
              </mat-option>
              }
            </mat-select>
          </div>
          <div class="flex flex-col w-[25%] h-[74px] secondary-bg rounded-lg px-4 py-2.5 cursor-pointer"
            (click)="picker.open()">
            <span class="max-w-max secondary-bg text-secondary text-lg font-normal">Departure</span>
            <div class="flex flex-row">
              <input class="font-semibold text-xl mt-1 min-w-60 " [min]="minDate" (click)="picker.open()"
                [readonly]="true" [matDatepicker]="picker" formControlName="departure_date" />
              <mat-icon svgIcon="mat_outline:date_range" class="primary-text mt-1 cursor-pointer"
                (click)="picker.open()"></mat-icon>
            </div>
            <mat-datepicker #picker></mat-datepicker>
          </div>
          <div class="flex flex-col w-[25%] h-[74px] secondary-bg rounded-lg px-3 py-2.5 cursor-pointer"
            (click)="travellersClass()">
            <span class="max-w-max secondary-bg text-secondary text-lg font-normal">Pax</span>
            <span class="font-semibold text-xl mt-1 cursor-pointer">{{
              formGroup.get("adult").value + " Adults" + " " +
              formGroup.get("child").value + " Child" }}</span>
          </div>
        </div>
        <div class="flex flex-row justify-center items-center -mb-11 space-x-4">
          <button mat-flat-button class="w-50 min-h-13 rounded-lg primary-bg" (click)="detail()">
            <span class="white-text font-medium text-2xl">Search</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 4-->
@if (holidaysData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme4) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[375px] primary-bg w-full gray-text" style="background-image: url('{{holidaysData?.background_image}}');background-blend-mode: color !important;
    background-color: #0000007a !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[14rem]">
      <div class="flex flex-col">
        <div class="flex">
          <h1 class="text-center text-[52px] justify-center font-bold font-Dosis white-text flex w-full z-[99]">
            {{holidaysData?.title}}</h1>
        </div>
        <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote4">
            {{holidaysData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-xl mt-[-95px]">
    <div class="mr-6 rounded-[10px] min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup" class="flex flex-col px-4 pt-[6px] white-bg rounded-[22px] shadow-xl pb-5">
        <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
          <div class="flex flex-col min-w-[50%] max-w-[50%] h-[74px] py-3 pr-3 pl-[17px] cursor-pointer"
            (click)="destinationSelect.open()">
            <span class="text-lg pr-[8px] max-w-max font-normal text-secondary">Destination</span>
            <mat-select class="mt-1 pr-2 font-semibold text-xl" formControlName="destination_id" #destinationSelect
              [compareWith]="compareWith">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search Destination"
                  noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilterNew">
                </ngx-mat-select-search>
              </mat-option>
              @for (ct of destinationListNew ; track ct) {
              <mat-option [value]="ct">
                <div class="flex flex-col truncate max-w-full h-15 justify-center">
                  <span class="font-normal items-center text-base flex">
                    @if (ct.type == 'City') {
                    <mat-icon svgIcon="heroicons_outline:building-office-2"></mat-icon>
                    }
                    @if (ct.type == 'Destination') {
                    <mat-icon svgIcon="heroicons_outline:map-pin"></mat-icon>
                    }
                    {{ct.name}}
                  </span>
                </div>
              </mat-option>
              }
            </mat-select>
            <div class="gray-border mt-[3px] w-full border-t-2"></div>
          </div>
          <div class="flex flex-col w-[25%] h-[74px] rounded-lg px-3 py-2.5 cursor-pointer" (click)="picker.open()">
            <span class="max-w-max text-secondary text-lg font-normal">Departure</span>
            <input class="font-semibold text-xl mt-1 min-w-60" [min]="minDate" (click)="picker.open()" [readonly]="true"
              [matDatepicker]="picker" formControlName="departure_date" />
            <mat-datepicker #picker></mat-datepicker>
            <div class="gray-border mt-[3px] w-full border-t-2"></div>
          </div>
          <div class="flex flex-col w-[25%] h-[74px] px-3 py-2.5 cursor-pointer" (click)="travellersClass()">
            <span class="max-w-max text-secondary text-lg font-normal">Pax</span>
            <span class="font-semibold text-xl mt-1 cursor-pointer">{{
              formGroup.get("adult").value + " Adults" + " " +
              formGroup.get("child").value + " Child" }}</span>
            <div class="gray-border mt-[3px] w-full border-t-2"></div>
          </div>
        </div>
        <div class="flex flex-row justify-center items-center -mb-[47px] space-x-4">
          <button mat-flat-button class="w-60 min-h-13 rounded-full primary-bg" (click)="detail()">
            <span class="white-text font-medium text-2xl">Search</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 5-->
@if (holidaysData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme5) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-row bg-center justify-center items-center bg-no-repeat h-[540px] primary-bg w-full"
    style="background-image: url('{{holidaysData?.background_image}}');background-blend-mode: color !important;
    background-color: #000000b3 !important;">
    <div class="flex flex-row gap-6 min-w-[1260px] max-w-[1260px] h-full">
      <div class="flex flex-col h-full items-center justify-center w-1/2">
        <div class="flex flex-col gap-[2px]">
          <div class="flex">
            <h1
              class="text-center text-[52px] justify-center font-bold font-Racing_Sans_One white-text flex w-full z-[99] tracking-[4px]">
              {{holidaysData?.title}}</h1>
          </div>
          <div class="flex text-base justify-center font-Inter white-text">
            <div class="text-center w-[500px] z-[99] textNote4 font-normal gray-text">
              {{holidaysData?.description}}</div>
          </div>
        </div>
      </div>
      <div class="w-1/2 h-full flex flex-col">
        <form [formGroup]="formGroup" class="flex flex-col h-full w-full justify-center gap-3 theme5-form-field">
          <div class="flex flex-col white-bg rounded-lg shadow-xl p-5 w-full gap-5">
            <mat-form-field class="w-full">
              <mat-label class="text-secondary text-base font-normal">Destination</mat-label>
              <mat-select class="font-medium text-black max-w-[523px] text-[15px] pr-1" [compareWith]="compareWith"
                formControlName="destination_id">
                <mat-option>
                  <ngx-mat-select-search placeholderLabel="Search Destination"
                    noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilterNew">
                  </ngx-mat-select-search>
                </mat-option>
                @for (ct of destinationListNew; track ct) {
                <mat-option [value]="ct">
                  <div class="flex flex-col truncate max-w-full h-15 justify-center">
                    <span class="font-normal items-center text-base flex">
                      @if (ct.type == 'City') {
                      <mat-icon svgIcon="heroicons_outline:building-office-2"></mat-icon>
                      }
                      @if (ct.type == 'Destination') {
                      <mat-icon svgIcon="heroicons_outline:map-pin"></mat-icon>
                      }
                      {{ct.name}}
                    </span>
                  </div>
                </mat-option>
                }
              </mat-select>
              <mat-icon svgIcon="feather:map-pin" class="icon-size-5 gray-text"></mat-icon>
            </mat-form-field>
            <div class="flex flex-row gap-3">
              <mat-form-field class="w-1/2">
                <mat-label class="text-secondary text-base font-normal">Departure</mat-label>
                <input matInput class="font-medium text-black text-[15px]" [min]="minDate" (click)="picker.open()"
                  [readonly]="true" [matDatepicker]="picker" formControlName="departure_date"
                  (onchange)="changeDate($event)" />
                <mat-datepicker #picker></mat-datepicker>
                <mat-icon svgIcon="feather:calendar" class="icon-size-5 gray-text" (click)="picker.open()"></mat-icon>
              </mat-form-field>
              <div class="flex flex-col w-1/2 h-[74px]" (click)="travellersClass()">
                <span class="text-secondary text-base font-normal pb-[4px] leading-5">Pax</span>
                <span
                  class="font-medium text-[15px] text-black cursor-pointer rounded-md border-[1px] py-[12px] px-4 flex flex-row justify-between"
                  [ngClass]="isOpenPax ? 'border-[#4f46e5]' :'border-[#737373]'">{{formGroup.get("adult").value + "
                  Adults" + " " +
                  formGroup.get("child").value + " Child" }}
                  <mat-icon svgIcon="feather:user" class="icon-size-5 gray-text"></mat-icon>
                </span>
              </div>
            </div>
            <div class="flex justify-center items-center py-1">
              <button mat-flat-button class="w-full py-[26px] rounded-lg primary-bg" (click)="detail()">
                <span class="white-text font-medium text-[17px]">Search</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
}
<!-- theme 6 -->
@if (holidaysData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme6) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[400px] primary-bg w-full gray-text" style="background-image: url('{{holidaysData?.background_image}}');background-blend-mode: color !important;
background-color: #0000007a !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[18rem]">
      <div class="flex flex-col">
        <div class="flex">
          <h1
            class="text-center text-[52px] justify-center font-bold font-Racing_Sans_One white-text flex w-full z-[99] tracking-[4px]">
            {{holidaysData?.title}}</h1>
        </div>
        <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote4">
            {{holidaysData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="pt-3">
    <div class="min-w-[1260px] max-w-[1260px] m-auto mt-[-62px] relative z-[99]">
      <div class="min-w-[1260px] max-w-[1260px] m-auto rounded-[10px]">
        <form [formGroup]="formGroup" class="flex flex-col">
          <div class="flex flex-row w-full overflow-hidden rounded-[65px] shadow-xl white-bg h-[100px]">
            <div class="flex flex-row w-full">
              <div
                class="flex flex-col border-r gray-border min-w-[560px] max-w-[560px] justify-center pl-13 cursor-pointer"
                [ngClass]="selectedField == 'destination' ? 'secondary-bg' : ''" (click)="destinationSelect.open()">
                <span class="font-normal text-[15px] font-Roboto text-secondary">Destination</span>
                <mat-select (click)="selectedField = 'destination'" #destinationSelect
                  class="pt-1 font-bold rounded-[5px] pr-[15px] text-xl" formControlName="destination_id"
                  [compareWith]="compareWith">
                  <mat-option>
                    <ngx-mat-select-search placeholderLabel="Search Destination"
                      noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilterNew">
                    </ngx-mat-select-search>
                  </mat-option>
                  @for (ct of destinationListNew; track ct) {
                  <mat-option [value]="ct">
                    <div class="flex flex-col justify-center ml-3">
                      <span class="font-medium items-center flex">
                        @if (ct.type == 'City') {
                        <mat-icon svgIcon="heroicons_outline:building-office-2"></mat-icon>
                        }
                        @if (ct.type == 'Destination') {
                        <mat-icon svgIcon="heroicons_outline:map-pin"></mat-icon>
                        }
                        {{ct.name}}
                      </span>
                    </div>
                  </mat-option>
                  }
                </mat-select>
              </div>
              <div
                class="flex flex-col pl-[11px] min-w-[250px] w-[250px] max-w-[250px] border-r gray-border justify-center cursor-pointer"
                [ngClass]="selectedField == 'departure' ? 'secondary-bg' : ''"
                (click)="picker.open();selectedField = 'departure'">
                <div class="">
                  <mat-label class="white-text text-[15px] items-center gap-1 flex">
                    <span class="pt-1 pb-1 pr-1"><img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                        alt="date_icon"></span>
                    <span class="ml-0 pr-3 pt-[2px] text-secondary">Departure</span>
                  </mat-label>
                  <input readonly class="font-Roboto font-bold text-xl pt-0.5 cursor-pointer max-w-[200px]" matInput
                    [matDatepicker]="picker" [min]="minDate" (click)="picker.open();selectedField = 'departure'"
                    formControlName="departure_date">
                  <mat-datepicker-toggle matSuffix [for]="picker" class="hidden"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </div>
              </div>
              <div class="min-w-[250px] w-[250px] max-w-[250px] flex flex-col pl-2.5 justify-center cursor-pointer"
                [ngClass]="selectedField == 'pax' ? 'secondary-bg' : ''"
                (click)="travellersClass();selectedField = 'pax'">
                <span class="text-[15px] rounded-lg w-full h-[24px] text-secondary">Pax</span>
                <div class="truncate pr-3 w-full rounded-md font-Roboto font-bold text-xl pt-0.5 cursor-pointer">
                  {{formGroup.get("adult").value + " Adults" + " " + formGroup.get("child").value
                  +"
                  Child"}}
                </div>
              </div>
              <div class="w-full h-full justify-center flex items-center">
                <button class="primary-bg rounded-full py-8 px-13" mat-flat-button (click)="detail()">
                  <span class="white-text font-normal text-2xl font-Roboto">Search</span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
}
<!--Theme 7 -->
@if (holidaysData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme7) {
<div class="flex flex-col w-full items-center mobile:hidden tablet:hidden relative h-[635px]">
  <div class="absolute top-[-73px] w-full h-[710px] z-10"
    [style]="'background-image: url('+holidaysData?.background_image+');background-blend-mode: color !important; background-color: rgb(0 0 0 / 70%) !important; background-repeat: no-repeat;background-size: cover;background-position: center;'">
  </div>
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[475px] primary-bg w-full gray-text">
    <div class="flex flex-col h-full items-center justify-center max-h-[14rem] mt-[73px]">
      <div class="flex flex-col">
        <div class="flex">
          <h1
            class="text-center text-[52px] justify-center font-normal leading-[65px] font-[ui-serif] white-text flex w-full z-[99]">
            {{holidaysData?.title}}</h1>
        </div>
        <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote4">
            {{holidaysData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-xl mt-[-100px]">
    <div class="mr-6 rounded-b-xl min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup"
        class="flex flex-col p-5 pb-1.5 pt-2 white-bg rounded-b-xl shadow-xl theme7-form-field">
        <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
          <mat-form-field class="min-w-[50%] max-w-[50%]">
            <mat-label class="text-secondary text-lg font-normal">Destination</mat-label>
            <mat-select class="font-medium text-[17px] h-[60px]" [compareWith]="compareWith"
              formControlName="destination_id">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search Destination"
                  noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilterNew">
                </ngx-mat-select-search>
              </mat-option>
              @for (ct of destinationListNew; track ct) {
              <mat-option [value]="ct">
                <div class="flex flex-col truncate max-w-full h-15 justify-center">
                  <span class="font-normal items-center text-base flex">
                    @if (ct.type == 'City') {
                    <mat-icon svgIcon="heroicons_outline:building-office-2"></mat-icon>
                    }
                    @if (ct.type == 'Destination') {
                    <mat-icon svgIcon="heroicons_outline:map-pin"></mat-icon>
                    }
                    {{ct.name}}
                  </span>
                </div>
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="w-[25%]">
            <mat-label class="text-secondary text-lg font-normal">Departure</mat-label>
            <input matInput class="font-medium text-[17px] h-[60px]" [min]="minDate" (click)="picker.open()"
              [readonly]="true" [matDatepicker]="picker" formControlName="departure_date"
              (onchange)="changeDate($event)" />
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <div class="flex flex-col w-[25%] cursor-pointer" (click)="travellersClass()">
            <span class="text-secondary text-lg font-normal pb-[4px] leading-5">Pax</span>
            <span
              class="font-medium text-[17px] cursor-pointer rounded-[10px] border-[1px] pt-[18px] pb-[17px] px-4 flex flex-row justify-between"
              [ngClass]="isOpenPax ? 'border-[#4f46e5]' :'border-[#c2c2c799]'">{{formGroup.get("adult").value + "
              Adults" + " " +
              formGroup.get("child").value + " Child" }}
            </span>
          </div>
          <div class="flex justify-center items-end pl-1">
            <button mat-flat-button class="w-36 min-h-[65px] rounded-lg primary-bg" (click)="detail()">
              <span class="white-text font-medium text-2xl">Search</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 8 -->
@if (holidaysData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme8) {
<div class="flex flex-col w-full items-center mobile:hidden tablet:hidden relative h-[575px]">
  <div class="absolute top-[-73px] w-full h-[650px] z-10"
    [style]="'background-image: url('+holidaysData?.background_image+');background-blend-mode: color !important; background-color: rgb(0 0 0 / 70%) !important; background-repeat: no-repeat;background-size: cover;background-position: center;'">
  </div>
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[475px] primary-bg w-full gray-text">
    <div class="flex flex-col h-full items-center justify-center max-h-[14.5rem] mt-[120px]">
      <div class="flex flex-col">
        <div class="flex">
          <h1 class="text-center text-[41px] justify-center font-normal leading-[65px] white-text flex w-full z-[99]">
            {{holidaysData?.title}}</h1>
        </div>
        <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote4">
            {{holidaysData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-2xl mt-[-100px]">
    <div class="mr-6 rounded-2xl min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup" class="flex flex-col rounded-2xl bg-[#0a0707ab] border light-border px-5 py-6">
        <div class="flex flex-row w-full overflow-hidden rounded-[5px] shadow-xl white-bg">
          <div class="flex flex-row w-full">
            <div class="flex flex-col justify-center border-r gray-border min-w-[550px] max-w-[550px] cursor-pointer"
              [ngClass]="selectedField == 'destination' ? 'secondary-bg' : ''" (click)="destinationSelect.open()">
              <span class="font-normal text-[15px] pl-6 font-Roboto text-secondary">Destination</span>
              <mat-select (click)="selectedField = 'destination'" #destinationSelect
                class="pl-[22px] pt-1  rounded-[5px] pr-[15px] font-Roboto font-medium text-xl"
                formControlName="destination_id" [compareWith]="compareWith">
                <mat-option>
                  <ngx-mat-select-search placeholderLabel="Search Destination"
                    noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilterNew">
                  </ngx-mat-select-search>
                </mat-option>
                @for (ct of destinationListNew; track ct) {
                <mat-option [value]="ct">
                  <div class="flex flex-col justify-center ml-3">
                    <span class="font-medium items-center flex">
                      @if (ct.type == 'City') {
                      <mat-icon svgIcon="heroicons_outline:building-office-2"></mat-icon>
                      }
                      @if (ct.type == 'Destination') {
                      <mat-icon svgIcon="heroicons_outline:map-pin"></mat-icon>
                      }
                      {{ct.name}}
                    </span>
                  </div>
                </mat-option>
                }
              </mat-select>
            </div>
            <div
              class="flex flex-col pl-[15px] min-w-[230px] max-w-[230px] border-r gray-border justify-center cursor-pointer"
              [ngClass]="selectedField == 'departure' ? 'secondary-bg' : ''" (click)="picker.open()">
              <div class="ml-[7px]">
                <mat-label class="white-text items-center gap-1 flex">
                  <span class="pt-1 pb-1 pr-1"><img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                      alt="date_icon"></span>
                  <span class="ml-0 pr-3 pt-[2px] font-Roboto text-[15px] text-secondary font-normal">Departure</span>
                </mat-label>
                <input readonly class="font-Roboto font-medium text-xl cursor-pointer max-w-[200px]" matInput
                  [matDatepicker]="picker" [min]="minDate" (click)="picker.open();selectedField = 'departure'"
                  formControlName="departure_date">
                <mat-datepicker-toggle matSuffix [for]="picker" class="hidden"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </div>
            </div>
            <div class="min-w-[230px] w-full flex flex-col justify-center pl-5 cursor-pointer"
              [ngClass]="selectedField == 'pax' ? 'secondary-bg' : ''"
              (click)="travellersClass();selectedField = 'pax'">
              <span class="text-[15px] rounded-lg w-full h-[24px] text-secondary">Pax</span>
              <div class="truncate pr-3 w-full rounded-md font-Roboto font-medium text-xl cursor-pointer">
                {{formGroup.get("adult").value + " Adults" + " " + formGroup.get("child").value
                +"
                Child"}}
              </div>
            </div>
            <div class="w-[192px] min-w-[192px] h-full justify-end flex items-center">
              <button class="primary-bg rounded-none h-[75px] min-h-[75px] w-full" mat-flat-button (click)="detail()">
                <span class="white-text font-normal text-2xl font-Roboto">Search</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 9 -->
@if (holidaysData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme9) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden h-[635px]">
  <div class="absolute top-[-73px] w-full h-[600px] z-10"
    [style]="'background-image: url('+holidaysData?.background_image+');background-blend-mode: color !important; background-color: #000000bd !important; background-repeat: no-repeat;background-size: cover;background-position: center;'">
  </div>
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[352px] primary-bg w-full gray-text">
    <div class="flex flex-col h-full items-center justify-center max-h-[14.5rem]">
      <div class="flex flex-col">
        <div class="flex">
          <h1 class="text-center text-[46px] justify-center font-semibold white-text flex w-full z-[99]">
            {{holidaysData?.title}}
          </h1>
        </div>
        <div class="flex text-xl justify-center font-normal font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote4">
            {{holidaysData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-[12px]">
    <div class="mr-6 rounded-[12px] min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup" class="flex flex-col px-4 pt-[6px] white-bg rounded-[12px] shadow-xl pb-5">
        <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
          <div class="flex flex-col min-w-[50%] max-w-[50%] h-[74px] py-3 pr-3 pl-[17px] cursor-pointer"
            (click)="destinationSelect.open()">
            <span class="text-lg pr-[8px] max-w-max font-normal text-secondary">Destination</span>
            <mat-select class="mt-1 pr-2 font-medium text-xl" formControlName="destination_id" #destinationSelect
              [compareWith]="compareWith">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search Destination"
                  noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilterNew">
                </ngx-mat-select-search>
              </mat-option>
              @for (ct of destinationListNew; track ct) {
              <mat-option [value]="ct">
                <div class="flex flex-col truncate max-w-full h-15 justify-center">
                  <span class="font-normal items-center text-base flex">
                    @if (ct.type == 'City') {
                    <mat-icon svgIcon="heroicons_outline:building-office-2"></mat-icon>
                    }
                    @if (ct.type == 'Destination') {
                    <mat-icon svgIcon="heroicons_outline:map-pin"></mat-icon>
                    }
                    {{ct.name}}
                  </span>
                </div>
              </mat-option>
              }
            </mat-select>
            <div class="gray-border mt-[3px] w-full border-t-2"></div>
          </div>
          <div class="flex flex-col w-[25%] h-[74px] rounded-lg px-3 py-2.5 cursor-pointer" (click)="picker.open()">
            <span class="max-w-max text-secondary text-lg font-normal">Departure</span>
            <input class="font-medium text-xl mt-1 min-w-60" [min]="minDate" (click)="picker.open()" [readonly]="true"
              [matDatepicker]="picker" formControlName="departure_date" />
            <mat-datepicker #picker></mat-datepicker>
            <div class="gray-border mt-[3px] w-full border-t-2"></div>
          </div>
          <div class="flex flex-col w-[25%] h-[74px] px-3 py-2.5 cursor-pointer" (click)="travellersClass()">
            <span class="max-w-max text-secondary text-lg font-normal">Pax</span>
            <span class="font-medium text-xl mt-1 cursor-pointer">{{
              formGroup.get("adult").value + " Adults" + " " +
              formGroup.get("child").value + " Child" }}</span>
            <div class="gray-border mt-[3px] w-full border-t-2"></div>
          </div>
        </div>
        <div class="flex flex-row justify-center items-center -mb-[42px] space-x-4">
          <button mat-flat-button class="w-60 min-h-13 rounded-full primary-bg" (click)="detail()">
            <span class="white-text font-medium text-2xl">Search</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 10 -->
@if (holidaysData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme10) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden relative">
  <div class="absolute top-0 w-full h-[375px] flex flex-row items-end">
    <div class="w-full min-h-full h-full relative">
      <div style="background-image: url(assets/images/b2c/theme_10_header_img.svg);
                background-repeat: no-repeat;
                background-position: right;
                background-size: cover;" class="z-10 min-h-full h-full w-[55%] absolute top-0 left-0"></div>
      <img loading="lazy" [src]="holidaysData?.background_image" alt="background_image"
        class="object-cover bg-left h-full w-1/2 absolute top-0 right-0">
    </div>
  </div>
  <div class="flex flex-col bg-no-repeat h-[375px] bg-[#F9F9F9] w-full gray-text">
    <div class="flex flex-col min-w-[1260px] max-w-[1260px] m-auto h-full items-center justify-center">
      <div class="flex flex-col w-full">
        <div class="flex">
          <h1 class="text-[52px] justify-start font-bold font-Dosis theme-black-text flex w-[50%] z-[99] pr-2">
            {{holidaysData?.title}}
          </h1>
        </div>
        <div class="flex text-xl justify-start font-Ibm_Plex_Sans_Devanagari theme-black-text w-[50%] pr-2">
          <div class="w-full z-[99] textNote4">
            {{holidaysData?.description}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-2xl mt-[-40px]">
    <div class="mr-6 rounded-2xl min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup" class="flex flex-row white-bg rounded-[5px] overflow-hidden shadow-xl">
        <div class="flex flex-row w-full overflow-hidden rounded-[5px] white-bg">
          <div class="flex flex-row w-full">
            <div class="flex flex-col justify-center border-r gray-border min-w-[550px] max-w-[550px] cursor-pointer"
              (click)="destinationSelect.open()" [ngClass]="selectedField == 'destination' ? 'secondary-bg' : ''">
              <span class="font-normal text-[15px] pl-6 font-Roboto text-secondary">Destination</span>
              <mat-select (click)="selectedField = 'destination'" #destinationSelect
                class="pl-[22px] pt-1 rounded-[5px] pr-[15px] font-Roboto font-medium text-xl"
                formControlName="destination_id" [compareWith]="compareWith">
                <mat-option>
                  <ngx-mat-select-search placeholderLabel="Search Destination"
                    noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilterNew">
                  </ngx-mat-select-search>
                </mat-option>
                @for (ct of destinationListNew; track ct) {
                <mat-option [value]="ct">
                  <div class="flex flex-col justify-center ml-3">
                    <span class="font-medium items-center flex">
                      @if (ct.type == 'City') {
                      <mat-icon svgIcon="heroicons_outline:building-office-2"></mat-icon>
                      }
                      @if (ct.type == 'Destination') {
                      <mat-icon svgIcon="heroicons_outline:map-pin"></mat-icon>
                      }
                      {{ct.name}}
                    </span>
                  </div>
                </mat-option>
                }
              </mat-select>
            </div>
            <div
              class="flex flex-col pl-[15px] min-w-[230px] max-w-[230px] border-r gray-border justify-center cursor-pointer"
              [ngClass]="selectedField == 'departure' ? 'secondary-bg' : ''" (click)="picker.open()">
              <div class="ml-[7px]">
                <mat-label class="white-text items-center gap-1 flex">
                  <span class="pt-1 pb-1 pr-1"><img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                      alt="date_icon"></span>
                  <span class="ml-0 pr-3 pt-[2px] font-Roboto text-[15px] text-secondary font-normal">Departure</span>
                </mat-label>
                <input readonly class="font-Roboto font-medium text-xl cursor-pointer max-w-[200px]" matInput
                  [matDatepicker]="picker" [min]="minDate" (click)="picker.open();selectedField = 'departure'"
                  formControlName="departure_date">
                <mat-datepicker-toggle matSuffix [for]="picker" class="hidden"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </div>
            </div>
            <div class="min-w-[230px] w-full flex flex-col justify-center pl-5 cursor-pointer"
              [ngClass]="selectedField == 'pax' ? 'secondary-bg' : ''"
              (click)="travellersClass();selectedField = 'pax'">
              <span class="text-[15px] rounded-lg w-full h-[24px] text-secondary">Pax</span>
              <div class="truncate pr-3 w-full rounded-md font-Roboto font-medium text-xl cursor-pointer">
                {{formGroup.get("adult").value + " Adults" + " " + formGroup.get("child").value
                +"
                Child"}}
              </div>
            </div>
            <div class="w-[192px] min-w-[192px] h-full justify-end flex items-center">
              <button class="primary-bg rounded-none h-[75px] min-h-[75px] w-full" mat-flat-button (click)="detail()">
                <span class="white-text font-normal text-2xl font-Roboto">Search</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 11 -->
@if (holidaysData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme11) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden xl:px-10 px-0">
  <div
    class="bg-cover flex flex-col bg-center bg-no-repeat h-[580px] xl:rounded-[30px] rounded-none primary-bg w-full gray-text"
    style="background-image: url('{{holidaysData?.background_image}}');background-blend-mode: color !important;
  background-color: #0000007a !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[14rem]">
      <div class="flex flex-col">
        <div class="flex">
          <h1 class="text-center text-[52px] justify-center font-bold font-Dosis white-text flex w-full z-[99]">
            {{holidaysData?.title}}</h1>
        </div>
        <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote4">
            {{holidaysData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] flex rounded-xl mt-[-300px]">
    <div class="mr-6 rounded-xl min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup" class="flex flex-col px-4 pt-18 white-bg pb-[18px] rounded-lg shadow-xl">
        <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
          <div
            class="flex flex-col min-w-[50%] max-w-[50%] h-[74px] py-3 px-2 secondary-bg rounded-[4px] cursor-pointer"
            (click)="destinationSelect.open()">
            <span class="text-lg secondary-bg px-[10px] max-w-max font-normal text-secondary">Destination</span>
            <mat-select class="mt-1 px-2 font-semibold text-xl" formControlName="destination_id" #destinationSelect
              [compareWith]="compareWith">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search Destination"
                  noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilterNew">
                </ngx-mat-select-search>
              </mat-option>
              @for (ct of destinationListNew; track ct) {
              <mat-option [value]="ct">
                <div class="flex flex-col truncate max-w-full h-15 justify-center">
                  <span class="font-normal items-center text-base flex">
                    @if (ct.type == 'City') {
                    <mat-icon svgIcon="heroicons_outline:building-office-2"></mat-icon>
                    }
                    @if (ct.type == 'Destination') {
                    <mat-icon svgIcon="heroicons_outline:map-pin"></mat-icon>
                    }
                    {{ct.name}}
                  </span>
                </div>
              </mat-option>
              }
            </mat-select>
          </div>
          <div class="flex flex-col w-[25%] h-[74px] secondary-bg rounded-[4px] px-4 py-2.5 cursor-pointer"
            (click)="picker.open()">
            <span class="max-w-max secondary-bg text-secondary text-lg font-normal">Departure</span>
            <div class="flex flex-row">
              <input class="font-semibold text-xl mt-1 min-w-60 " [min]="minDate" (click)="picker.open()"
                [readonly]="true" [matDatepicker]="picker" formControlName="departure_date" />
            </div>
            <mat-datepicker #picker></mat-datepicker>
          </div>
          <div class="flex flex-col w-[25%] h-[74px] secondary-bg rounded-[4px] px-3 py-2.5 cursor-pointer"
            (click)="travellersClass()">
            <span class="max-w-max secondary-bg text-secondary text-lg font-normal">Pax</span>
            <span class="font-semibold text-xl mt-1 cursor-pointer">{{
              formGroup.get("adult").value + " Adults" + " " +
              formGroup.get("child").value + " Child" }}</span>
          </div>
        </div>
        <div class="flex flex-row justify-center items-center -mb-11 pt-[20px] space-x-4">
          <button mat-flat-button class="w-64 min-h-13 rounded-full primary-bg" (click)="detail()">
            <span class="white-text font-medium text-2xl">Search</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 12 -->
@if (holidaysData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme12) {
<div class="flex flex-col w-full items-center mobile:hidden tablet:hidden relative h-[595px]">
  <div class="absolute top-[-73px] w-full h-[670px] z-10"
    [style]="'background-image: url('+holidaysData?.background_image+');background-blend-mode: color !important; background-repeat: no-repeat;background-size: cover;background-position: center;'">
  </div>
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[475px] primary-bg w-full gray-text">
    <div class="flex flex-col h-full items-center justify-center max-h-[11rem] mt-[73px]">
      <div class="flex flex-col">
        <div class="flex">
          <h1
            class="text-center text-[42px] justify-center font-normal leading-[65px] font-[ui-serif] white-text flex w-full z-[99]">
            {{holidaysData?.title}}</h1>
        </div>
        <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote3">
            {{holidaysData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-xl mt-[-100px]">
    <div class="mr-6 rounded-xl min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup"
        class="flex flex-col p-5 pt-3 pb-2.5 bg-[#000000bd] rounded-xl shadow-xl theme12-form-field">
        <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
          <mat-form-field class="min-w-[50%] max-w-[50%]">
            <mat-label class="text-[15px] text-white font-normal">Destination</mat-label>
            <mat-select class="font-medium py-[16px] text-[15px] pr-1" [compareWith]="compareWith"
              formControlName="destination_id">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search Destination"
                  noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilterNew">
                </ngx-mat-select-search>
              </mat-option>
              @for (ct of destinationListNew; track ct) {
              <mat-option [value]="ct">
                <div class="flex flex-col truncate max-w-full h-15 justify-center">
                  <span class="font-normal items-center text-base flex">
                    @if (ct.type == 'City') {
                    <mat-icon svgIcon="heroicons_outline:building-office-2"></mat-icon>
                    }
                    @if (ct.type == 'Destination') {
                    <mat-icon svgIcon="heroicons_outline:map-pin"></mat-icon>
                    }
                    {{ct.name}}
                  </span>
                </div>
              </mat-option>
              }
            </mat-select>
            <mat-icon svgIcon="feather:map-pin" class="icon-size-5 gray-text"></mat-icon>
          </mat-form-field>
          <mat-form-field class="w-[25%]">
            <mat-label class="text-[15px] text-white font-normal">Departure</mat-label>
            <input matInput class="font-medium py-[16px] text-[15px]" [min]="minDate" (click)="picker.open()"
              [readonly]="true" [matDatepicker]="picker" formControlName="departure_date"
              (onchange)="changeDate($event)" />
            <mat-datepicker #picker></mat-datepicker>
            <mat-icon svgIcon="feather:calendar" class="icon-size-5 gray-text" (click)="picker.open()"></mat-icon>
          </mat-form-field>
          <div class="flex flex-col w-[25%] h-[80px] cursor-pointer" (click)="travellersClass()">
            <span class="text-[15px] text-white font-normal pb-[4px] leading-5">Pax</span>
            <span
              class="font-medium text-[15px] cursor-pointer rounded-[9px] bg-white border-[1px] py-[1.05rem] px-4 flex flex-row justify-between"
              [ngClass]="isOpenPax ? 'border-[#4f46e5]' :'border-[#737373]'">{{formGroup.get("adult").value + " Adults"
              + " " +
              formGroup.get("child").value + " Child" }}
              <mat-icon svgIcon="feather:user" class="icon-size-5 gray-text"></mat-icon>
            </span>
          </div>
          <div class="flex justify-center items-end pl-1">
            <button mat-flat-button class="w-[70px] min-w-[70px] min-h-[60px] rounded-lg primary-bg text-white"
              (click)="detail()">
              <mat-icon svgIcon="feather:search" class="icon-size-8 font-light text-white"></mat-icon>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 13 -->
@if (holidaysData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme13) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[560px] primary-bg w-full gray-text" style="border-bottom-left-radius: 100% 250px;
     border-bottom-right-radius: 100% 250px;
     border-bottom: 14px solid white;
     background-color: #0000007a !important;
     background-image: url('{{holidaysData?.background_image}}');
     background-blend-mode: color !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[30rem]">
      <div class="flex flex-col min-w-[1260px] max-w-[1260px]">
        <div class="flex">
          <h1 class="text-[50px] font-semibold font-[cursive] white-text flex w-full z-[99] tracking-[7px]">
            {{holidaysData?.title}}</h1>
        </div>
        <div class="flex text-[30px] font-extralight pt-3 font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="w-[1000px] z-[99] textNote4 leading-[35px]">
            {{holidaysData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-[12px] mt-[-145px]">
    <div class="mr-6 rounded-[12px] min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup"
        class="flex flex-col px-5 pt-3 white-bg rounded-[12px] shadow-xl pb-5 theme12-form-field">
        <div class="flex flex-row w-full space-x-4 mt-3 mb-7">
          <mat-form-field class="min-w-[50%] max-w-[50%]">
            <mat-label class="text-[16px] unselected-text font-normal">Destination</mat-label>
            <mat-select class="font-medium py-[16px] text-[15px] pr-1" [compareWith]="compareWith"
              formControlName="destination_id">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search Destination"
                  noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilterNew">
                </ngx-mat-select-search>
              </mat-option>
              @for (ct of destinationListNew; track ct) {
              <mat-option [value]="ct">
                <div class="flex flex-col truncate max-w-full h-15 justify-center">
                  <span class="font-normal items-center text-base flex">
                    @if (ct.type == 'City') {
                    <mat-icon svgIcon="heroicons_outline:building-office-2"></mat-icon>
                    }
                    @if (ct.type == 'Destination') {
                    <mat-icon svgIcon="heroicons_outline:map-pin"></mat-icon>
                    }
                    {{ct.name}}
                  </span>
                </div>
              </mat-option>
              }
            </mat-select>
            <mat-icon matPrefix svgIcon="feather:map-pin" class="icon-size-5 gray-text"></mat-icon>
          </mat-form-field>
          <mat-form-field class="w-[25%]">
            <mat-label class="text-[16px] unselected-text font-normal">Departure</mat-label>
            <input matInput class="font-medium py-[16px] text-[15px]" [min]="minDate" (click)="picker.open()"
              [readonly]="true" [matDatepicker]="picker" formControlName="departure_date"
              (onchange)="changeDate($event)" />
            <mat-datepicker #picker></mat-datepicker>
            <mat-icon matPrefix svgIcon="feather:calendar" class="icon-size-5 gray-text"
              (click)="picker.open()"></mat-icon>
          </mat-form-field>
          <div class="flex flex-col w-[25%] h-[80px] cursor-pointer" (click)="travellersClass()">
            <span class="text-[16px] unselected-text font-normal pb-[4px] leading-5">Pax</span>
            <span
              class="font-medium text-[15px] cursor-pointer rounded-[9px] bg-white border-[1px] pt-[16px] pb-[17px] px-4 flex flex-row gap-3"
              [ngClass]="isOpenPax ? 'border-[#4f46e5]' :'border-[#d2d2d2]'">
              <mat-icon svgIcon="feather:user" class="icon-size-5 gray-text"></mat-icon>
              {{formGroup.get("adult").value + " Adults" + " " +
              formGroup.get("child").value + " Child" }}
            </span>
          </div>
        </div>
        <div class="flex flex-row justify-center items-center -mb-[50px] space-x-4">
          <button mat-flat-button class="w-64 min-h-[60px] rounded-full primary-bg" (click)="detail()">
            <span class="white-text font-medium text-2xl">Search</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 14 -->
@if (holidaysData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme14) {
<div class="flex flex-col w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[510px] primary-bg w-full gray-text" style="background-image: url('{{holidaysData?.background_image}}');background-blend-mode: color !important;
 background-color: #0000007a !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[24rem] pt-[70px]">
      <div class="flex flex-col min-w-[1260px] max-w-[1260px]">
        <div class="flex">
          <h1 class="text-[48px] font-medium white-text w-full z-[99]" style="font-family: sans-serif;">
            {{holidaysData?.title}}</h1>
        </div>
        <div class="flex text-[22px] font-normal font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="w-[650px] z-[99] textNote4">
            {{holidaysData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] flex mt-[-61px]">
    <div class="min-w-[1260px] max-w-[1260px] px-7 rounded-[18px] rounded-t-none white-bg shadow-xl">
      <form [formGroup]="formGroup" class="flex flex-col border-t-2 pt-4 pb-2">
        <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
          <div
            class="flex flex-col min-w-[50%] max-w-[50%] h-[74px] py-3 px-2 border-[1px] rounded-[10px] gray-border cursor-pointer"
            (click)="destinationSelect.open()">
            <span class="pl-1.5 max-w-max text-base font-medium text-secondary">Destination</span>
            <mat-select class="mt-1 pl-1.5 font-semibold text-lg" formControlName="destination_id" #destinationSelect
              [compareWith]="compareWith">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search Destination"
                  noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilterNew">
                </ngx-mat-select-search>
              </mat-option>
              @for (ct of destinationListNew; track ct) {
              <mat-option [value]="ct">
                <div class="flex flex-col truncate max-w-full h-15 justify-center">
                  <span class="font-normal items-center text-base flex">
                    @if (ct.type == 'City') {
                    <mat-icon svgIcon="heroicons_outline:building-office-2"></mat-icon>
                    }
                    @if (ct.type == 'Destination') {
                    <mat-icon svgIcon="heroicons_outline:map-pin"></mat-icon>
                    }
                    {{ct.name}}
                  </span>
                </div>
              </mat-option>
              }
            </mat-select>
          </div>
          <div class="flex flex-col w-[25%] h-[74px] border-[1px] rounded-[10px] gray-border p-3 cursor-pointer"
            (click)="picker.open()">
            <div class="max-w-max w-full flex flex-row justify-between text-secondary text-base min-w-full font-medium">
              <span class="font-medium text-secondary">Departure</span>
              <mat-icon svgIcon="mat_outline:date_range" class="gray-text icon-size-5 cursor-pointer"
                (click)="picker.open()"></mat-icon>
            </div>
            <div class="flex flex-row">
              <input class="font-semibold text-lg mt-1.5 min-w-60" [min]="minDate" (click)="picker.open()"
                [readonly]="true" [matDatepicker]="picker" formControlName="departure_date" />
            </div>
            <mat-datepicker #picker></mat-datepicker>
          </div>
          <div class="flex flex-col w-[25%] h-[74px] border-[1px] rounded-[10px] gray-border p-3 cursor-pointer"
            (click)="travellersClass()">
            <span class="max-w-max text-secondary text-base font-medium pl-0.5">Pax</span>
            <span class="font-semibold text-lg mt-1 cursor-pointer pl-0.5">{{
              formGroup.get("adult").value + " Adults" + " " +
              formGroup.get("child").value + " Child" }}</span>
          </div>
          <div class="flex flex-row justify-center items-end">
            <button mat-flat-button class="w-[73px] mb-0.5 min-w-[73px] min-h-[73px] rounded-lg primary-bg text-white"
              (click)="detail()">
              <mat-icon svgIcon="feather:search" class="icon-size-8 font-light text-white"></mat-icon>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 15 -->
@if (holidaysData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme15) {
<div class="flex flex-col w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[650px] primary-bg w-full gray-text" style="background-image: url('{{holidaysData?.background_image}}');background-blend-mode: color !important;
 background-color: #0000007a !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[17rem] pt-[70px]">
      <div class="flex flex-col min-w-[1260px] max-w-[1260px]">
        <div class="flex">
          <h1 class="text-[48px] text-center font-semibold white-text w-full z-[99]" style="font-family: sans-serif;">
            {{holidaysData?.title}}</h1>
        </div>
        <div class="flex text-[20px] white-text justify-center">
          <div class="w-[900px] z-[99] font-light textNote2 text-center">
            {{holidaysData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="absolute top-[335px] left-0 right-0 min-h-fit flex w-full justify-center">
    <div class="min-w-[1260px] max-w-[1260px] z-[99] flex">
      <div class="min-w-[1260px] max-w-[1260px] px-7 rounded-[18px] white-bg shadow-xl"
        [ngClass]="{ 'rounded-tl-none' : isFirstService }">
        <form [formGroup]="formGroup" class="flex flex-col pt-6 pb-2">
          <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
            <div
              class="flex flex-col min-w-[45%] max-w-[45%] h-[74px] py-3 px-2 border gray-border rounded-xl cursor-pointer"
              (click)="destinationSelect.open()">
              <span class="text-[15px] px-[10px] max-w-max font-normal text-secondary">Destination</span>
              <mat-select class="mt-1 px-2 font-semibold text-lg" formControlName="destination_id" #destinationSelect
                [compareWith]="compareWith">
                <mat-option>
                  <ngx-mat-select-search placeholderLabel="Search Destination"
                    noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilterNew">
                  </ngx-mat-select-search>
                </mat-option>
                @for (ct of destinationListNew; track ct) {
                <mat-option [value]="ct">
                  <div class="flex flex-col truncate max-w-full h-15 justify-center">
                    <span class="font-normal items-center text-base flex">
                      @if (ct.type == 'City') {
                      <mat-icon svgIcon="heroicons_outline:building-office-2"></mat-icon>
                      }
                      @if (ct.type == 'Destination') {
                      <mat-icon svgIcon="heroicons_outline:map-pin"></mat-icon>
                      }
                      {{ct.name}}
                    </span>
                  </div>
                </mat-option>
                }
              </mat-select>
            </div>
            <div class="flex flex-col w-[21%] h-[74px] border gray-border rounded-xl px-4 py-3 cursor-pointer"
              (click)="picker.open()">
              <span class="max-w-max text-secondary text-[15px] font-normal">Departure</span>
              <div class="flex flex-row">
                <input class="font-semibold text-lg mt-1 min-w-60 " [min]="minDate" (click)="picker.open()"
                  [readonly]="true" [matDatepicker]="picker" formControlName="departure_date" />
              </div>
              <mat-datepicker #picker></mat-datepicker>
            </div>
            <div class="flex flex-col w-[21%] h-[74px] border gray-border rounded-xl px-4 py-3 cursor-pointer"
              (click)="travellersClass()">
              <span class="max-w-max text-secondary text-[15px] font-normal">Pax</span>
              <span class="font-semibold text-lg mt-1 cursor-pointer">{{
                formGroup.get("adult").value + " Adults" + " " +
                formGroup.get("child").value + " Child" }}</span>
            </div>
            <div class="flex flex-row justify-center items-center">
              <button mat-flat-button class="w-[130px] min-h-18 rounded-xl primary-bg" (click)="detail()">
                <span class="white-text font-medium text-2xl">Search</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
}
<!--Theme 16 -->
@if (holidaysData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme16) {
<div class="flex flex-col w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[650px] primary-bg w-full gray-text" style="background-image: url('{{holidaysData?.background_image}}');background-blend-mode: color !important;
 background-color: #0000007a !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[17rem] pt-[70px]">
      <div class="flex flex-col justify-start min-w-[1260px] max-w-[1260px]">
        <h1 class="text-[48px] font-semibold white-text w-full z-[99] uppercase"
          style="font-family: 'Mina'; text-shadow: 2px 2px 4px rgba(0,0,0,0.4);">
          {{holidaysData?.title}}
        </h1>
        <div class="w-[900px] z-[99] text-[20px] white-text font-light textNote2"
          style="text-shadow: 1px 1px 3px rgba(0,0,0,0.3);">
          {{holidaysData?.description}}
        </div>
      </div>
    </div>
  </div>
  <div class="absolute top-[335px] left-0 right-0 min-h-fit flex w-full justify-center">
    <div class="min-w-[1260px] max-w-[1260px] z-[99] flex">
      <div class="min-w-[1260px] max-w-[1260px] bg-white/40 p-6 w-full backdrop-blur-md rounded-[20px] shadow-xl">
        <form [formGroup]="formGroup" class="flex flex-col ">
          <div class="flex flex-row w-full space-x-3">
            <div class="flex flex-col min-w-[45%] w-full h-[74px] py-3 px-2 bg-white rounded-2xl cursor-pointer"
              (click)="destinationSelect.open()">
              <span class="text-[15px] px-[10px] max-w-max font-normal text-secondary">Destination</span>
              <mat-select class="mt-1 px-2 font-semibold text-lg" formControlName="destination_id" #destinationSelect
                [compareWith]="compareWith">
                <mat-option>
                  <ngx-mat-select-search placeholderLabel="Search Destination"
                    noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilterNew">
                  </ngx-mat-select-search>
                </mat-option>
                @for (ct of destinationListNew; track ct) {
                <mat-option [value]="ct">
                  <div class="flex flex-col truncate max-w-full h-15 justify-center">
                    <span class="font-normal items-center text-base flex">
                      @if (ct.type == 'City') {
                      <mat-icon svgIcon="heroicons_outline:building-office-2"></mat-icon>
                      }
                      @if (ct.type == 'Destination') {
                      <mat-icon svgIcon="heroicons_outline:map-pin"></mat-icon>
                      }
                      {{ct.name}}
                    </span>
                  </div>
                </mat-option>
                }
              </mat-select>
            </div>
            <div class="flex flex-col min-w-[21%] w-full h-[74px] bg-white rounded-2xl px-4 py-3 cursor-pointer"
              (click)="picker.open()">
              <span class="max-w-max text-secondary text-[15px] font-normal">Departure</span>
              <div class="flex flex-row">
                <input class="font-semibold text-lg mt-1 min-w-60 " [min]="minDate" (click)="picker.open()"
                  [readonly]="true" [matDatepicker]="picker" formControlName="departure_date" />
              </div>
              <mat-datepicker #picker></mat-datepicker>
            </div>
            <div class="flex flex-col min-w-[21%] w-full h-[74px] bg-white rounded-2xl px-4 py-3 cursor-pointer"
              (click)="travellersClass()">
              <span class="max-w-max text-secondary text-[15px] font-normal">Pax</span>
              <span class="font-semibold text-lg mt-1 cursor-pointer">{{
                formGroup.get("adult").value + " Adults" + " " +
                formGroup.get("child").value + " Child" }}</span>
            </div>
            <div class="flex flex-row justify-center items-start">
              <button mat-flat-button class="rounded-xl min-h-[74px] primary-bg" (click)="detail()">
                <mat-icon class="text-white invert w-8 h-8" svgIcon="feather:search"></mat-icon>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
}
}